/*
 * Copyright 2026 NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService, MerchantService, NotificationService } from "../../../services";
import { MerchantDetailsParentComponent } from "../merchant-details-parent.component";
import { GlobalPaymentsAccountDetails, Merchant } from "../../../models";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-global-payments-details",
  templateUrl: "./global-payments-details.component.html"
})
export class GlobalPaymentsDetailsComponent extends MerchantDetailsParentComponent implements OnInit {
  globalPaymentsFormGroup!: FormGroup;
  editable = false;
  buttonName = "Update Global Payments Details";
  actionInProgress = false;
  @Input("merchant") merchant!: Merchant;

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
    merchantService: MerchantService,
    notificationService: NotificationService,
    authService: AuthService,
    private fb: FormBuilder
  ) {
    super(router, activatedRoute, merchantService, notificationService, authService);
  }

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.globalPaymentsFormGroup = this.fb.group({
      globalPaymentsMerchantName: [
        this.merchant.accountDetails.globalPaymentsAccountDetails?.globalPaymentsMerchantName,
        [Validators.required, Validators.maxLength(100)]
      ],
      globalPaymentsSiteId: [
        this.merchant.accountDetails.globalPaymentsAccountDetails?.globalPaymentsSiteId,
        [Validators.required, Validators.maxLength(50)]
      ],
      globalPaymentsKey: [
        this.merchant.accountDetails.globalPaymentsAccountDetails?.globalPaymentsKey,
        [Validators.required, Validators.maxLength(50)]
      ]
    });
  }

  setEditable(value: boolean): void {
    this.editable = value;
  }

  receiveEditEvent(value: boolean) {
    this.editable = value;
    this.createForm();
  }

  updateGlobalPaymentsDetails() {
    if (this.globalPaymentsFormGroup.valid) {
      this.actionInProgress = true;
      const globalPaymentsAccountDetails: GlobalPaymentsAccountDetails = JSON.parse(
        JSON.stringify(this.merchant.accountDetails.globalPaymentsAccountDetails)
      );
      globalPaymentsAccountDetails.globalPaymentsMerchantName =
        this.globalPaymentsFormGroup.controls.globalPaymentsMerchantName.value;
      globalPaymentsAccountDetails.globalPaymentsSiteId =
        this.globalPaymentsFormGroup.controls.globalPaymentsSiteId.value;
      globalPaymentsAccountDetails.globalPaymentsKey = this.globalPaymentsFormGroup.controls.globalPaymentsKey.value;
      this.merchantService.updateGlobalPaymentsAccountDetails(this.merchant.id, globalPaymentsAccountDetails).subscribe(
        (globalPaymentsAccountDetails) => {
          this.merchant.accountDetails.globalPaymentsAccountDetails = globalPaymentsAccountDetails;
          this.editable = false;
          this.actionInProgress = false;
        },
        (error) => {
          this.notificationService.error(error.error);
          this.actionInProgress = false;
        }
      );
    } else {
      this.globalPaymentsFormGroup.markAllAsTouched();
    }
  }
}
